<shift-warning-tooltip
  [absenceWarning]="absenceWarning"
  [doubleRegistration]="doubleRegistration"
  [deviatesFromSchedule]="deviatesFromSchedule"
>
  @if (absenceWarning) {
    <div>{{ 'Already absent' | translate }}</div>
  }
  @if (doubleRegistration) {
    <div>{{ 'Overlapping registration' | translate }}</div>
  }
  @if (deviatesFromSchedule) {
    <div>{{ 'Deviates from schedule' | translate }}</div>
  }
</shift-warning-tooltip>
